import { render, staticRenderFns } from "./ReorderEducations.vue?vue&type=template&id=2eaeef74&scoped=true"
import script from "./ReorderEducations.vue?vue&type=script&lang=js"
export * from "./ReorderEducations.vue?vue&type=script&lang=js"
import style0 from "./ReorderEducations.vue?vue&type=style&index=0&id=2eaeef74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaeef74",
  null
  
)

/* custom blocks */
import block0 from "./ReorderEducations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports